import { ChatPanel } from './ChatPanel';
import { CHAT_WIDGET_COPY } from './chat-widget.constants';

/** Shown when the ChatWerk loader cannot be fetched (offline, blocked). */
export function ChatLoadError({ id, onClose }: { id: string; onClose: () => void }) {
    return (
        <ChatPanel id={id} title={CHAT_WIDGET_COPY.errorTitle} onClose={onClose}>
            <p role="alert" className="mt-2 text-sm text-(--muted)">
                {CHAT_WIDGET_COPY.errorText}
            </p>
        </ChatPanel>
    );
}
